import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { MenuLink } from '../../../../../utils/models/layout.interface';
import { heightSidenavMenu } from '../../../../shared/functions/utilities.service';
import { SharedModule } from 'src/app/shared/shared.module';
import { CommonModule } from '@angular/common';
import { IconInduxtryComponent } from '../../common/icon-induxtry/icon-induxtry.component';

@Component({
  selector: 'app-sidenav-menu',
  templateUrl: './sidenav-menu.component.html',
  styleUrls: ['./sidenav-menu.component.scss'],
  imports: [
      CommonModule,
      SharedModule,
      RouterLink,
      RouterLinkActive,
      IconInduxtryComponent
    ],
  standalone: true
})
export class SidenavMenuComponent implements OnInit, OnChanges {

  @Input() link: MenuLink;
  @Input() subMenu: boolean;
  @Input() collapse;
  @Input() child = false;
  @Output() linkClose: EventEmitter<boolean> = new EventEmitter<boolean>();

  myCollapse = false;
  isHovered = false;
  panelOpenState = false;

  constructor(private readonly router: Router) { }

  activeRoute(routeName: string): boolean {
    return this.router.url.indexOf(routeName) > -1;
  }

  handleClick(event: boolean): void {
    this.linkClose.emit(event);
  }

  handleClickRoute(route, event) {
    if (`/${route}` === this.router.url) {
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate([route]);
      });
    }
    this.handleClick(event);
  }

  ngOnChanges(change) {
    if (change.collapse) {
      this.myCollapse = this.collapse;
    }
  }

  ngOnInit() {
    this.myCollapse = false;
    heightSidenavMenu();
  }

  preventMenuClose(event: Event, type?) {
    if(type === 'secondary' || type === 'tertiary'){
      event.stopPropagation();
    }
  }
}
